import { Title, Stack } from '@mantine/core';
import { ArchitectureDiagram } from './ArchitectureDiagram';

export function ArchitecturePage() {
  return (
    <Stack gap="lg">
      <Title order={2}>Systemarchitektur</Title>
      <ArchitectureDiagram />
    </Stack>
  );
}
